import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Container, Card, Button } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCirclePlus, faList, faUser } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom';
import '../../../styles/diario.scss';


function ContratosLoggedScreen() {
    const [direct, setDirect] = useState(false);
    const nome = localStorage.getItem('nome');

    const getNivel = async () => {
        let user = localStorage.getItem('nivel');
        console.log(user)
        switch (user) {
            case "Administrador":
                await setDirect(false)
                break;
            case "Legislador":
                await setDirect("/restrito/leis")
                break;
            case "Licitador":
                await setDirect(false)
                break;
            case "Controle Interno":
                await setDirect(false)
                break;
        }
    }


    const redireciona = async () => {
        await getNivel();
    }

    useEffect(() => {
        redireciona()
    }, [])


    if (direct) {
        return <Navigate to={{ pathname: `${direct}` }} />
    } else {
        return (
            <Fragment>
                <Container>
                    <h5>Bem vindo, {nome}, o que deseja fazer?</h5><br />
                    <Row xs={1} lg={2}>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/contratos/cadastrar')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faFileCirclePlus} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Cadastrar Contrato</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>


                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/contratos/listar')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faList} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Listar Contratos</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/contratos/fiscais')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faUser} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Fiscais de Contrato</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Fragment>
                        <br /><br />
                        <Link to={'/restrito/licitacao'}>
                            <Button variant="danger" type="button">
                                Voltar
                            </Button>
                        </Link>
                    </Fragment>

                </Container>
            </Fragment>
        );
    }
}

export default ContratosLoggedScreen;